import { CustomFieldComponentProps } from '../CustomFieldComponent'
import PageSwitch from '../../DonationForm/components/atoms/PageSwitch'

const CustomSwitch = ({
  id,
  name,
  label,
  onChange,
  value,
  defaultValue,
  conditionalFields,
  CustomFieldComponent,
}: CustomFieldComponentProps) => {
  const isChecked = value ? value === 'true' : defaultValue === 'true'
  return (
    <>
      <PageSwitch
        id={`custom-field-${name}`}
        name={name}
        label={label}
        onChange={(e) => {
          onChange?.({
            target: {
              name: id,
              value: `${e}`,
            },
          } as React.ChangeEvent<HTMLInputElement>)
        }}
        isChecked={isChecked}
      />
      {isChecked &&
        conditionalFields &&
        CustomFieldComponent &&
        conditionalFields.map((field) => (
          <CustomFieldComponent {...field} {...field.customField!} key={field.customField!.id} onChange={onChange} />
        ))}
    </>
  )
}

export default CustomSwitch
